export const isPetsOnlyAllowedInVehicle = (routeCode: string): boolean => {
  return ['GBDVR-FRCQF', 'GBDVR-FRDKK', 'FRDKK-GBDVR', 'FRCQF-GBDVR', 'FRDPE-GBNHV', 'GBNHV-FRDPE'].includes(routeCode)
}
